/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/
export const CONSTANTS = {
  validPasswordRegex: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,}$/,
  validUsernameRegex: /^[a-z0-9_]*$/,
  defaultPageLimit: 25,
  defaultHeavyPageLimit: 10,
  states: [
    'Alabama',
    'Alaska',
    'Arizona',
    'Arkansas',
    'California',
    'Colorado',
    'Connecticut',
    'Delaware',
    'Florida',
    'Georgia',
    'Hawaii',
    'Idaho',
    'Illinois',
    'Indiana',
    'Iowa',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Maine',
    'Maryland',
    'Massachusetts',
    'Michigan',
    'Minnesota',
    'Mississippi',
    'Missouri',
    'Montana',
    'Nebraska',
    'Nevada',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'New York',
    'North Carolina',
    'North Dakota',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Vermont',
    'Virginia',
    'Washington',
    'West Virginia',
    'Wisconsin',
    'Wyoming',
  ] as const,
};
export const DATE_TIME_FORMAT = "MM/dd/yyyy '@' h:mm:ss a";
export const DATE_TIME_NO_SECONDS_FORMAT = 'MM/dd/yyyy h:mm a';
export const PORTRAIT_ASPECT_RATIO = '9:16';
export const LANDSCAPE_ASPECT_RATIO = '16:9';
export const PORTRAIT_ASPECT_RATIO_VALUE = 9 / 16;
export const LANDSCAPE_ASPECT_RATIO_VALUE = 16 / 9;

// Display order for role dropdowns throughout the app
export const ROLE_DISPLAY_ORDER = [
  'Nurse',
  'Nurse Manager',
  'Pharmacy Technician',
  'Pharmacist',
  'Pharmacy Manager',
  'Diversion Committee',
  'Administrator',
  'Super User',
  'Building Services',
] as const;

export function sortByRoleDisplayOrder<T extends { name: string }>(roles: T[]): T[] {
  return [...roles].sort((a, b) => {
    const aIndex = ROLE_DISPLAY_ORDER.indexOf(a.name as (typeof ROLE_DISPLAY_ORDER)[number]);
    const bIndex = ROLE_DISPLAY_ORDER.indexOf(b.name as (typeof ROLE_DISPLAY_ORDER)[number]);
    return (aIndex === -1 ? ROLE_DISPLAY_ORDER.length : aIndex) - (bIndex === -1 ? ROLE_DISPLAY_ORDER.length : bIndex);
  });
}
